import React from 'react'

export const RedirectSingleSpa = ({ to }: { to: string }) => {
    window.history.pushState(null, '', to)
    return <></>
}
